// removed by extract-text-webpack-plugin
module.exports = {"frozen":"scroll__frozen--1Q9Bb"};


//////////////////
// WEBPACK FOOTER
// ./src/utils/scroll.css
// module id = ./src/utils/scroll.css
// module chunks = 4